export const CoreActionsTypes = {
  SELECT_COMPANY: '[Global Ui] Select Company',
  SELECT_PROPERTY: '[Global Ui] Select Property',
  SAVE_FLAGS: '[Global Ui] Save Flags',
  SELECT_SEASONS: '[Global Ui] Select Seasons',
  SELECT_REGION: '[Global Ui] Select Region',
  SELECT_AREA: '[Global Ui] Select Area',
  CHANGE_DASHBOARD_STATE: '[Global Ui] Change Dashboard State',
  TOGGLE_MONITORING_DRAWER: '[Global Ui] Toggle Monitoring Drawer',
  CHANGE_UNIT_SYSTEM: '[Global Ui] Change unit system',
  CHANGE_INTERFACE_LANGUAGE: '[Global Ui] Change interface language'
} as const;
